import React, {
  FunctionComponent,
  ReactNode,
  useEffect,
  useState,
} from "react";
import { withNamespaces, WithNamespaces } from "react-i18next";
import { Router } from "react-router-dom";

import "./bootstrap-grid.scss";
import { PopinOptin, Routes } from "./components";
import CookiesAgreement from "./components/CookiesAgreement";
import environment from "./environment";
import i18n from "./i18n";
import "./index.css";
import history from "./lib/history";
import { notify } from "./lib/toaster";
import { translate } from "./services/translation.service";
import {
  IMenuContentNormed,
  ITarget2Sell,
  ITarget2SellPageParams,
  IUrlState,
} from "./types/global";

interface IDispoMag {
  userLocation: () => void;
  getGeoLocation: () => void;
  requestStoreList: () => void;
  initAutocomplete: () => void;
}

declare global {
  // tslint:disable-next-line
  interface Window {
    __initialUrlState: IUrlState | null | undefined;
    __initialMenuContent?: { [key: string]: IMenuContentNormed[] };
    _t2sparams: ITarget2SellPageParams | undefined;
    T2S: ITarget2Sell;
    T2SRecoStarted: boolean;
    initDispoMag: (
      // tslint:disable-next-line: no-any
      createStoreList: any,
      // tslint:disable-next-line: no-any
      clearStoreList: any,
      { sku, baseUrl }: { sku: string; baseUrl: string }
    ) => IDispoMag;
    dispoMag?: IDispoMag;
    // tslint:disable-next-line: no-any
    google?: { maps: any };
    SC_DISABLE_SPEEDY?: boolean;
    // tslint:disable-next-line: no-any
    ga?: any;
    // tslint:disable-next-line: no-any
    purser?: any;
  }
}

import(/* webpackChunkName: "sentry-browser" */ "@sentry/browser").then(
  // tslint:disable-next-line: typedef
  (Sentry) => {
    Sentry.init({
      dsn: environment.SENTRY.DSN,
      environment: environment.SENTRY.ENV,
      release: process.env.REACT_APP_VERSION,
    });
    // tslint:disable-next-line: no-console
    console.log("✓ Sentry is watching.");
  }
);

interface IAppProps {
  lng: string;
}

const App = (({ lng }: IAppProps): ReactNode => {
  const [language, setLanguage] = useState(lng);

  /**
   * Plug the setLanguage state setter to i18n's language changed event
   * Plug listeners on network
   */
  useEffect(() => {
    i18n.on("languageChanged", setLanguage);

    const online = (): void => notify(translate("toaster.connectionRestored"));
    const offline = (): void => notify(translate("toaster.connectionlost"));

    window.addEventListener("online", online);
    window.addEventListener("offline", offline);

    return (): void => {
      i18n.off("languageChanged", setLanguage);

      window.removeEventListener("online", online);
      window.removeEventListener("offline", offline);
    };
  }, []);

  return (
    <Router history={history} key={language}>
      <CookiesAgreement />
      <Routes />
      <PopinOptin />
    </Router>
  );
}) as FunctionComponent<IAppProps & WithNamespaces>;

export default withNamespaces()(App);
